import React from 'react';
import { isEmpty } from 'lodash';
import { getCurrentSelectedOption } from '../../rselect/ReactSelectUtils';
import { ValidationTypes } from '../../../../constants/schemaEditor';
import { VALIDATION_FORMAT_OPTIONS } from '../../../../constants/attributeFormats';
import UIUtils from '../../../../lib/UIUtils';

class SchemaValidationItemInfo extends React.Component {
  render() {
    const {
      validation: { type, attrs, options },
    } = this.props;

    if (isEmpty(attrs)) {
      return (
        <span className="schema-validation-rule-description invalid-rule">
          No attributes selected.
        </span>
      );
    }

    const readableAttrList = UIUtils.renderAndJoin(
      attrs,
      (attr) => (
        <span key={attr} className="attr-name">
          {attr}
        </span>
      ),
      ', ',
      ' and ',
    );

    switch (type) {
      case ValidationTypes.REQUIRED:
        return (
          <span className="schema-validation-rule-description">
            Record must contain {readableAttrList}.
          </span>
        );

      case ValidationTypes.FORMAT:
        if (isEmpty(options.formats)) {
          return (
            <span className="schema-validation-rule-description invalid-rule">
              No format selected.
            </span>
          );
        }

        return (
          <span className="schema-validation-rule-description">
            {readableAttrList} must be of type{' '}
            {UIUtils.renderAndJoin(
              options.formats,
              (format, index) => (
                <span key={index} className="attr-name">
                  {getCurrentSelectedOption(VALIDATION_FORMAT_OPTIONS, format).label}
                </span>
              ),
              ', ',
              ' or ',
            )}
            .
          </span>
        );

      case ValidationTypes.RANGE:
      case ValidationTypes.SIZE:
        if (!options.min && !options.max) {
          return (
            <span className="schema-validation-rule-description invalid-rule">
              No range specified.
            </span>
          );
        }

        const descriptionText = type === ValidationTypes.RANGE ? 'must be ' : 'must have size ';

        if (!options.max) {
          return (
            <span className="schema-validation-rule-description">
              {readableAttrList} {descriptionText}
              <span className="attr-name">greater than or equal to {options.min}</span>.
            </span>
          );
        }

        if (!options.min) {
          return (
            <span className="schema-validation-rule-description">
              {readableAttrList} {descriptionText}
              <span className="attr-name">less than or equal to {options.max}</span>.
            </span>
          );
        }

        return (
          <span className="schema-validation-rule-description">
            {readableAttrList} {descriptionText}
            <span className="attr-name">
              between {options.min} and {options.max}
            </span>
            .
          </span>
        );

      case ValidationTypes.ENUM:
        if (isEmpty(options.values)) {
          return (
            <span className="schema-validation-rule-description invalid-rule">
              No valid values added.
            </span>
          );
        }

        return (
          <span className="schema-validation-rule-description">
            {readableAttrList} must have one of these values:{' '}
            {UIUtils.renderAndJoin(
              options.values,
              (value, index) => (
                <span key={index} className="attr-name">
                  {value}
                </span>
              ),
              ', ',
              ' or ',
            )}
            .
          </span>
        );

      case ValidationTypes.PATTERN:
        if (!options.pattern) {
          return (
            <span className="schema-validation-rule-description invalid-rule">
              No pattern specified.
            </span>
          );
        }

        return (
          <span className="schema-validation-rule-description">
            {readableAttrList} must match the pattern{' '}
            <span className="attr-name">{options.pattern}</span>.
          </span>
        );

      default:
    }
  }
}

export default SchemaValidationItemInfo;
